export default __webpack_public_path__ + "static/media/top-menu.ca0c6484.svg";